module.exports = __webpack_public_path__ + "static/img/101369.6999122c.png";